import { createSelector } from 'reselect'

const getShowPokemon = state => state.filter.showPokemon;
const getPokemon = state => state.marker.pokemon;
const getPokemonQuality = state => state.filter.pokemonQuality;
const getPokemonSpecies = state => state.filter.pokemonSpecies;
const getBounds = state => state.map.mapBounds;
const getHidden = state => state.marker.hidden;

export const selectVisiblePokemon = createSelector(
	[getShowPokemon, getPokemon, getPokemonQuality, getPokemonSpecies, getBounds, getHidden],
	(showPokemon, pokemon, pokemonQuality, pokemonSpecies, bounds, hidden) => {
		if( !showPokemon )
			return [];

		let list = Object.values(pokemon);

		list = list.filter(data =>
			data.latitude  < bounds[0][0] && data.latitude  > bounds[1][0] &&
			data.longitude < bounds[0][1] && data.longitude > bounds[1][1]
		);

		if( pokemonQuality === 90 ) // Hacky, this is the "Spawns With IVs" setting
			list = list.filter(pokemon => pokemon.cp > 0);
		else if( pokemonQuality > 0 )
			list = list.filter(pokemon => pokemon.quality >= pokemonQuality);

		if( pokemonSpecies.length )
			list = list.filter(pokemon => pokemonSpecies.includes(pokemon.pokemon_id));

		if( Object.entries(hidden).length )
			list = list.filter(pokemon => !hidden['pokemon-' + pokemon.encounter_id]);

		return list;
	}
);
